export const SaveButtonState = {
    idle: 'idle',
    saving: 'saving',
    saved: 'saved',
    error: 'error',
}